import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { gate } from 'hub-http/gates';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { getCategoryUrl } from '../utils/DetailsPageUrls';
import { Languages } from './Languages';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DetailsTab({
  companyName,
  companyUrl,
  category,
  languages,
  installCount,
  onTrackInteraction = () => {}
}) {
  var _userInfo$gates;
  const {
    appContext,
    isEmbedded,
    productType,
    published,
    runLeadGen,
    userInfo
  } = useDetailsPageContext();
  const isUngatedForAgentInstallStatus = userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('Marketplace:agent-install-status'));
  const isPreview = !published;
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "300",
    children: /*#__PURE__*/_jsxs(DescriptionList, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.builtBy"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: companyUrl ?
        /*#__PURE__*/
        // TODO: added check for agent marketplace, remove this check when we get guaranteed companyUrl from unified details
        _jsx(Link, {
          href: companyUrl,
          external: true,
          onClick: () => {
            runLeadGen({
              action: 'CLICKED_COMPANY_WEBSITE'
            });
            onTrackInteraction({
              action: 'clicked company website'
            });
          },
          children: companyName
        }) : /*#__PURE__*/_jsx(Text, {
          children: companyName
        })
      }), typeof installCount === 'number' && (productType !== 'AGENT' || isUngatedForAgentInstallStatus) &&
      /*#__PURE__*/
      //TODO: reinstate install count for agents once OFF_PLATFORM install count is instated
      _jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.productDetailsCard.installs"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: formatInstalls(installCount)
        })]
      }), category && category.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.productDetailsCard.categories"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "row",
            marginBlockStart: "100",
            children: category.map((categoryItem, index) => /*#__PURE__*/_jsx(View, {
              display: "inline-block",
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(Link, {
                disabled: isPreview,
                external: isEmbedded,
                hideExternalLinkIcon: isEmbedded,
                href: getCategoryUrl({
                  appContext,
                  category: categoryItem,
                  productType
                }),
                onClick: () => {
                  onTrackInteraction({
                    action: 'clicked category link',
                    value: categoryItem
                  });
                },
                children: /*#__PURE__*/_jsx(Tag, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `detailsPage.category.${categoryItem}`
                  })
                })
              })
            }, index))
          })
        })]
      }), languages && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `detailsPage.productDetailsCard.languages.${productType}`
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(Languages, {
            languages: languages
          })
        })]
      })]
    })
  });
}